export default "__VITE_ASSET__GMMQplso__"